<template>
    <transition name="fade">
        <div class="toastMessageBox" v-show="show">
            <!-- <img v-show="type == 'success'" src="../../../assets/img/success.png" /> -->
            <!-- <img v-show="type == 'error'" src="../../../assets/img/error.png"> -->
            <div>
                {{ message }}
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "toastMessage",
    data() {
        return {
            message: "",
            show: false,
            type: "info",
        };
    },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.toastMessageBox {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: fixed;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 16px;
    font-size: 14px;
    border-radius: 6px;
    text-align: center;
    z-index: 100000;
    width: 140px;
    min-height: 90px;
    box-sizing: border-box;
    img {
        display: block;
        width: 30px;
        height: 30px;
        object-fit: cover;
        margin-bottom: 8px; 
    }
}
</style>
